import React, { useEffect, type ReactNode } from 'react';
import { useAuth } from '../../shared/context/AuthContext';
import {
  bindConsultoriaIdentity,
  clearConsultoriaSession,
} from '../services/consultoriaSession';
// Side-effect: register logout run-cancel hook (must load before first logout).
import '../services/consultoriaClient';
import { ConsultoriaChatProvider } from './ConsultoriaChatContext';

/**
 * Binds the in-memory AI credential to company_id+user_id and remounts the
 * OPS chat provider whenever identity changes (logout / user switch).
 */
export const ConsultoriaIdentityBridge: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  const identityKey = user ? `${user.company_id}:${user.id}` : 'anon';

  useEffect(() => {
    if (user?.id && user.company_id) {
      bindConsultoriaIdentity(String(user.company_id), String(user.id));
      return;
    }
    clearConsultoriaSession();
  }, [user?.id, user?.company_id]);

  return <ConsultoriaChatProvider key={identityKey}>{children}</ConsultoriaChatProvider>;
};
